declare global {
    interface Date {
        /**
         * Metodo para obtener el primer dia de la semana de la fecha actual
         */
        firstDayOfWeek(firstDayOfWeekIndex: number): Date;
        lastDayOfWeek(lastDayOfWeekIndex: number): Date;
    }
}
export {};

Date.prototype.firstDayOfWeek = function ( firstDayOfWeekIndex: number = 1): Date {
    const dayOfWeek = this.getDay(),
        firstDayOfWeek = new Date(this),
        diff = dayOfWeek >= firstDayOfWeekIndex ? dayOfWeek - firstDayOfWeekIndex : 6 - dayOfWeek
    firstDayOfWeek.setDate(this.getDate() - diff);
    firstDayOfWeek.setHours(0, 0, 0, 0);

    return firstDayOfWeek;
}

Date.prototype.lastDayOfWeek = function (lastDayOfWeekIndex: number): Date {
    const dayOfWeek = this.getDay(),
        lastDayOfWeek = new Date(this),
        diff = (lastDayOfWeekIndex + (7 - dayOfWeek)) % 7;
    lastDayOfWeek.setDate(this.getDate() + diff);
    return lastDayOfWeek;
}

